import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const API_BASE = 'https://psri.k3lpaser.com/api';

const statusColor = {
  aktif: { bg: 'bg-green-50', text: 'text-green-700', border: 'border-green-200', label: 'Aman' },
  perlu_perhatian: { bg: 'bg-yellow-50', text: 'text-yellow-700', border: 'border-yellow-200', label: 'Waspada' },
  tidak_siap: { bg: 'bg-red-50', text: 'text-red-700', border: 'border-red-200', label: 'Kritis' },
  tidak_aktif: { bg: 'bg-red-50', text: 'text-red-700', border: 'border-red-200', label: 'Kritis' },
};

function formatTanggal(dateStr) {
  if (!dateStr) return '-';
  const d = new Date(dateStr);
  return d.toLocaleDateString('id-ID', { day: '2-digit', month: 'short', year: 'numeric' });
}

function Check({ ok }) {
  if (ok === 'na') {
    return (
      <span className="inline-flex items-center justify-center w-6 h-6 rounded text-xs font-bold bg-gray-100 text-gray-400">
        &ndash;
      </span>
    );
  }
  return (
    <span className={`inline-flex items-center justify-center w-6 h-6 rounded text-xs font-bold ${
      ok ? 'bg-green-600 text-white' : 'bg-red-100 text-red-600'
    }`}>
      {ok ? '\u2713' : '\u2715'}
    </span>
  );
}

export default function PublicKartuApar() {
  const { giId, aparId } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE}/public/apar/${giId}/${aparId}`)
      .then(res => res.json())
      .then(res => {
        if (res.status === 'success') setData(res.data);
        else setError(res.message || 'APAR tidak ditemukan');
      })
      .catch(() => setError('Gagal memuat data. Periksa koneksi internet Anda.'))
      .finally(() => setLoading(false));
  }, [giId, aparId]);

  const handleMulaiInspeksi = () => {
    window.location.href = `psri://apar/${giId}/${aparId}`;
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-green-600"></div>
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8 text-center max-w-sm">
          <div className="text-4xl mb-3">\u26A0\uFE0F</div>
          <p className="text-gray-700 font-semibold mb-1">Kartu tidak ditemukan</p>
          <p className="text-sm text-gray-400">{error}</p>
        </div>
      </div>
    );
  }

  const { header, riwayat } = data;
  const sc = statusColor[header.status] || statusColor.aktif;

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-md mx-auto">

        <div className="text-center mb-4">
          <span className="inline-flex items-center gap-1.5 bg-green-100 text-green-700 text-xs font-bold px-3 py-1 rounded-full">
            <span className="w-1.5 h-1.5 rounded-full bg-green-600 animate-pulse"></span>
            KARTU INSPEKSI VIRTUAL
          </span>
          <p className="text-[11px] text-gray-400 mt-1.5">Data selalu terbaru, langsung dari database PSRI</p>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 mb-4">
          <div className="flex justify-between items-start mb-4">
            <div>
              <p className="font-mono font-bold text-lg text-gray-800">{header.kode_apar}</p>
              <p className="text-xs text-gray-400 mt-0.5">{header.gardu_induk} &middot; {header.lokasi_penempatan}</p>
            </div>
            <span className={`text-xs font-bold px-3 py-1 rounded-full border ${sc.bg} ${sc.text} ${sc.border}`}>
              {sc.label}
            </span>
          </div>

          <div className="grid grid-cols-2 gap-3 pt-4 border-t border-gray-100">
            <div>
              <p className="text-[10px] text-gray-400 uppercase font-semibold">Jenis Isi</p>
              <p className="text-sm font-semibold text-gray-700">{header.jenis_isi}</p>
            </div>
            <div>
              <p className="text-[10px] text-gray-400 uppercase font-semibold">Berat</p>
              <p className="text-sm font-semibold text-gray-700">{header.berat}</p>
            </div>
            <div>
              <p className="text-[10px] text-gray-400 uppercase font-semibold">Tanggal Isi</p>
              <p className="text-sm font-semibold text-gray-700">{formatTanggal(header.tgl_pengisian)}</p>
            </div>
            <div>
              <p className="text-[10px] text-gray-400 uppercase font-semibold">Kedaluwarsa</p>
              <p className="text-sm font-semibold text-amber-600">{formatTanggal(header.tgl_expired)}</p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 mb-4">
          <p className="text-xs font-bold text-green-700 uppercase tracking-wide mb-3">Riwayat Kondisi</p>
          {riwayat.length === 0 ? (
            <p className="text-sm text-gray-400 text-center py-4">Belum ada riwayat inspeksi</p>
          ) : (
            <table className="w-full text-center">
              <thead>
                <tr className="text-[9px] text-gray-400 uppercase font-bold">
                  <th className="text-left pb-2">Tanggal</th>
                  <th className="pb-2">Tabung</th>
                  <th className="pb-2">Selang</th>
                  <th className="pb-2">Nozzle</th>
                  <th className="pb-2">PI</th>
                  <th className="pb-2">Handle</th>
                </tr>
              </thead>
              <tbody>
                {riwayat.map((r, i) => (
                  <tr key={i} className={i === 0 ? 'bg-green-50' : ''}>
                    <td className="text-left py-2 text-xs font-mono font-semibold text-gray-700">{formatTanggal(r.tanggal)}</td>
                    <td className="py-2"><Check ok={r.tabung} /></td>
                    <td className="py-2"><Check ok={r.selang} /></td>
                    <td className="py-2"><Check ok={r.nozzle} /></td>
                    <td className="py-2"><Check ok={r.pi} /></td>
                    <td className="py-2"><Check ok={r.handle} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <button onClick={handleMulaiInspeksi}
          className="w-full bg-green-700 text-white font-semibold py-3.5 rounded-xl shadow-sm hover:bg-green-600 transition-colors">
          Mulai Inspeksi &rarr;
        </button>
        <p className="text-[11px] text-gray-400 text-center mt-2">
          Tombol ini membuka aplikasi PSRI. Belum punya aplikasi? Hubungi admin ULTG Paser.
        </p>

        <p className="text-center text-[11px] text-gray-300 mt-8">PSRI &middot; ULTG Paser &middot; Diakses tanpa login</p>
      </div>
    </div>
  );
}
